import { PlatformLocation } from '@angular/common';
var QuestionnaireHeadPhotoComponent = (function () {
    function QuestionnaireHeadPhotoComponent(platformLocation) {
        this.platformLocation = platformLocation;
    }
    QuestionnaireHeadPhotoComponent.prototype.ngOnInit = function () {
        this.origin = this.platformLocation['location']['origin'];
    };
    QuestionnaireHeadPhotoComponent.prototype.ngAfterViewInit = function () {
    };
    return QuestionnaireHeadPhotoComponent;
}());
export { QuestionnaireHeadPhotoComponent };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-head-photo/questionnaire-head-photo.component.ts.pre-build-optimizer.js